"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.offerType = exports.offerRateType = exports.offerPackageType = exports.incomeRequestType = void 0;

var _propTypes = _interopRequireDefault(require("prop-types"));

var offerType = _propTypes.default.shape({
  id: _propTypes.default.string,
  rate: _propTypes.default.number,
  otherRate: _propTypes.default.number,
  primeRate: _propTypes.default.number,
  term: _propTypes.default.number,
  tier: _propTypes.default.number,
  originationFee: _propTypes.default.number,
  min: _propTypes.default.number,
  minDraw: _propTypes.default.number,
  max: _propTypes.default.number,
  maxDraw: _propTypes.default.number,
  minOther: _propTypes.default.number,
  minOtherDraw: _propTypes.default.number,
  maxOther: _propTypes.default.number,
  maxOtherDraw: _propTypes.default.number,
  type: _propTypes.default.string
});

exports.offerType = offerType;

var offerRateType = _propTypes.default.shape({
  type: _propTypes.default.string,
  min: _propTypes.default.number,
  minDraw: _propTypes.default.number,
  max: _propTypes.default.number,
  maxDraw: _propTypes.default.number,
  minOther: _propTypes.default.number,
  minOtherDraw: _propTypes.default.number,
  maxOther: _propTypes.default.number,
  maxOtherDraw: _propTypes.default.number,
  offers: _propTypes.default.arrayOf(offerType)
});

exports.offerRateType = offerRateType;

var incomeRequestType = _propTypes.default.shape({
  uuid: _propTypes.default.string,
  plaidItemUuids: _propTypes.default.arrayOf(_propTypes.default.string),
  vendor: _propTypes.default.string,
  methods: _propTypes.default.arrayOf(_propTypes.default.string),
  verificationMethod: _propTypes.default.string
});

exports.incomeRequestType = incomeRequestType;

var offerPackageType = _propTypes.default.shape({
  applicationUuid: _propTypes.default.string,
  decision: _propTypes.default.string,
  nonAutopayAdditionalRate: _propTypes.default.number,
  declineReasons: _propTypes.default.arrayOf(_propTypes.default.string),
  min: _propTypes.default.number,
  minDraw: _propTypes.default.number,
  max: _propTypes.default.number,
  maxDraw: _propTypes.default.number,
  minOther: _propTypes.default.number,
  minOtherDraw: _propTypes.default.number,
  maxOther: _propTypes.default.number,
  maxOtherDraw: _propTypes.default.number,
  maxDtiUnlimited: _propTypes.default.number,
  maxDtiUnlimitedDraw: _propTypes.default.number,
  hasOriginationFees: _propTypes.default.bool,
  hasMultipleOriginationFees: _propTypes.default.bool,
  offersByType: _propTypes.default.arrayOf(offerRateType),
  incomeVerificationResultUuid: _propTypes.default.string,
  subDecision: _propTypes.default.string,
  plaidItemUuids: _propTypes.default.arrayOf(_propTypes.default.string),
  statedTotalIncome: _propTypes.default.number,
  verifiedTotalIncome: _propTypes.default.number,
  incomeRequestRecords: _propTypes.default.arrayOf(incomeRequestType),
  incomeResultRecordUuids: _propTypes.default.arrayOf(_propTypes.default.string),
  rateDiscountResponse: _propTypes.default.arrayOf(_propTypes.default.shape({
    type: _propTypes.default.string,
    amount: _propTypes.default.number
  }))
});

exports.offerPackageType = offerPackageType;